export const config = {
    baseUrl: 'https://hr-backend-one.vercel.app',
    headers: {
        'Content-Type': 'application/json'
    }
}